export default __webpack_public_path__ + "media/images/wt-logo-invoice-3ab777a2.png";